import React from "react";
import "../scss/Footer.scss";
import { Link } from "react-router-dom";
import logo from "../Images/logo.png";
import { RiArrowDownFill, RiArrowUpCircleFill } from "react-icons/ri";
import facebook from "../Images/facebook.svg";
import twitter from "../Images/twitter.svg";
import instagram from "../Images/insta.svg";
import { useGlobalContext } from "../components/Context";
import sublinks from "./data";

const Footer = () => {
	const {
		myRef,
		scrollToTop,
		openFooterMenu,
		sendWaitlist,
		openDropdown,
		changeHandler,
		data,
		handleModal,
	} = useGlobalContext();

	return (
		<>
			<div className="newsletter" ref={myRef}>
				<p className="newsletter__topic">Sign up for our newsletter</p>
				<p className="newsletter__text">
					Be up-to-date about our services. Have access to exclusive deals and
					offers.
					<br />
					With insight into the current state of the market.
				</p>
				<div className="newsletter__mail">
					<form
						name="contact-details"
						method="POST"
						netlify
						onSubmit={sendWaitlist}>
						<input
							type="email"
							name="email"
							value={data.email}
							onChange={changeHandler}
							placeholder="Enter Email"
						/>

						<button
							type="submit"
							value="Subscribe"
							onClick={handleModal}
							className="newsletter__button">
							Join WaitList
						</button>
					</form>
				</div>
			</div>

			<div className="footer">
				<div className="footer__logo-wrapper">
					<div className="footer__logo">
						<img src={logo} alt="foote_logo" />
					</div>
					<p className="footer__words">
						iExchange - let's you convert, send, pay and get paid in the
						currency that suits you.
					</p>
					<li>
						<a
							href="https://medium.com/@info_2360"
							target="_blank"
							rel="noreferrer">
							Blog
						</a>
					</li>
					<div className="footer__icons">
						<img
							src={facebook}
							alt="foote_logo"
							className=" footer__icons-fb"
						/>
						<a href="https://twitter.com/iExchangeNG1">
							<img
								src={twitter}
								alt="foote_logo"
								className="footer__icons-tw"
							/>
						</a>

						<img
							src={instagram}
							alt="foote_logo"
							className="footer__icons-ins"
						/>
					</div>
				</div>
				{sublinks.map((item, id) => {
					const { links, page, classname } = item;
					return (
						<>
							<div className={classname}>
								<div className="footer__ull">
									<p key={id} onClick={openFooterMenu}>
										{page}
									</p>
									<ul
										className={!openDropdown ? "footer__ul" : "footer__active"}>
										{links.map((link, index) => {
											const { url, label, target } = link;
											return (
												<Link
													key={index}
													to={url}
													onClick={scrollToTop}
													target={target}>
													<li>{label}</li>
												</Link>
											);
										})}
									</ul>
								</div>
								<div className="footer__arrows" onClick={openFooterMenu}>
									{openDropdown ? <RiArrowDownFill /> : <RiArrowUpCircleFill />}
								</div>
							</div>
						</>
					);
				})}
			</div>
			<p className="copyright">
				Copyright &copy; 2021 iExchange. All Rights Reserved.
			</p>
			{/* <Modal/> */}
		</>
	);
};

export default Footer;
